import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import './TooltippedElement.less';

export default function PopoverElement(props) {
  const { tooltip } = props;

  const renderTooltip = (props) => (
    <Popover id="facts-popover" {...props}>
      <Popover.Body style={stylePopoverBody}>
        {tooltip}
        {' '}
      </Popover.Body>
    </Popover>
  );

    return (
        <>
            {tooltip && <OverlayTrigger
                placement="top"
                overlay={renderTooltip}
            >
                {props.disabled ? <span className="d-inline-block">{props.children}</span> : props.children}
            </OverlayTrigger>}
            {!tooltip && props.children}
        </>)
};


const stylePopoverBody = {
  fontSize: '13px',
  lineHeight: '18px',
  textAlign: 'center',
  padding: '28px 20px',
  color: '#72808E',
};
